var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-wrapper landing-wrapper"},[_c('Navbar'),_c('div',{staticClass:"landing-content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }